import { createSlice, PayloadAction } from '@reduxjs/toolkit';


interface AuthState {
  filterValue: string;
  filterData: FilterDataState;
  searchTerm: string;


}
interface FilterDataState {

  departmentNames: string[];
  designationNames: string[];
  gradeNames: string[];
  reportingToNames: string[];

}


const initialState: AuthState = {
  filterValue: 'active',
  filterData: {
    departmentNames: [],
    designationNames: [],
    gradeNames: [],
    reportingToNames: []
  },
  searchTerm: '',
};

const tableFilterSlice = createSlice({
  name: 'tableFilter',
  initialState,
  reducers: {
    setTableFilter: (state, action: PayloadAction<string>) => {
      state.filterValue = action.payload;
    },
    clearTableFilter: state => {
      state.filterValue = 'All Employees';
    },
    setFilterData: (state, action: PayloadAction<Partial<FilterDataState>>) => {
      state.filterData = { ...state.filterData, ...action.payload };
    },
    setSearchTerm: (state, action: PayloadAction<string>) => {
      state.searchTerm = action.payload;
    },
    clearSearchTerm: state => {
      state.searchTerm = '';
    },

  },
});

export const { setTableFilter, clearTableFilter, setFilterData, setSearchTerm } = tableFilterSlice.actions;
export default tableFilterSlice.reducer;
